/* Wildtree card color dots: on devices that can hover, preview the hovered/keyboard-focused color's image on the card.
   Touch devices skip the preview (a tap navigates away before it could be undone), and every swapped image
   is restored when the page is left or restored from the back/forward cache. */
(function () {
  if (window.__wtColors) return;
  window.__wtColors = true;

  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function cardImage(link) {
    var card = link.closest('.card-wrapper');
    return card ? card.querySelector('.card__media img') : null;
  }

  function preview(link) {
    var url = link.getAttribute('data-wt-img');
    var img = cardImage(link);
    if (!url || !img) return;
    if (!img.hasAttribute('data-wt-orig-src')) {
      img.setAttribute('data-wt-orig-src', img.getAttribute('src') || '');
      img.setAttribute('data-wt-orig-srcset', img.getAttribute('srcset') || '');
    }
    img.removeAttribute('srcset');
    img.setAttribute('src', url);
  }

  function restoreImg(img) {
    if (!img || !img.hasAttribute('data-wt-orig-src')) return;
    var src = img.getAttribute('data-wt-orig-src');
    var set = img.getAttribute('data-wt-orig-srcset');
    if (src) img.setAttribute('src', src);
    if (set) img.setAttribute('srcset', set);
    img.removeAttribute('data-wt-orig-src');
    img.removeAttribute('data-wt-orig-srcset');
  }

  function restoreAll() {
    document.querySelectorAll('img[data-wt-orig-src]').forEach(restoreImg);
  }

  function target(e) {
    return e.target && e.target.closest ? e.target.closest('.wt-color') : null;
  }

  document.addEventListener('mouseover', function (e) {
    if (!canHover) return;
    var t = target(e);
    if (t) preview(t);
  });
  document.addEventListener('mouseout', function (e) {
    var t = target(e);
    if (t) restoreImg(cardImage(t));
  });
  document.addEventListener('focusin', function (e) {
    var t = target(e);
    if (t && t.matches(':focus-visible')) preview(t);
  });
  document.addEventListener('focusout', function (e) {
    var t = target(e);
    if (t) restoreImg(cardImage(t));
  });
  window.addEventListener('pagehide', restoreAll);
  window.addEventListener('pageshow', restoreAll);
})();
